module.exports = __webpack_public_path__ + "img/Pro-tekt-logo.1ddf971c.png";